const observerAvailable =
    "IntersectionObserver" in window &&
    "IntersectionObserverEntry" in window &&
    "intersectionRatio" in window.IntersectionObserverEntry.prototype;

const getObserver = (config, callback, unobserve) => {
    if (!observerAvailable) return;

    return new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target;
                callback(element);

                if (unobserve) observer.unobserve(element);
            }
        });
    }, config);
};
export default function(identifier, config, callback, unobserve = true) {
    const elements = document.querySelectorAll(identifier);
    let observer;

    if (elements.length === 0) return;

    if (observerAvailable) observer = getObserver(config, callback, unobserve);

    for (const element of elements) {
        observerAvailable ? observer.observe(element) : callback(element);
    }
}
